import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Collapse from '@material-ui/core/Collapse'
import Switch from '@material-ui/core/Switch'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import SliderTransparency from './SliderTransparency'
import SliderFilter from './SliderFilter'
import SliderDatetimeContainer from '../containers/SliderDatetimeContainer'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import { makeGetLayerDisabled } from '../selectors/layerDisabledSelector'
import format from 'date-fns/format'
import getDateFromTimeIso from '../utility/getDateFromTimeIso'

import Legend from './Legend'
import transform from '../transforms'
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const styles = theme => ({
  
})

const filterProps = {
    min: 0,
    max: 300,
    value: 200,
    label: ' \u03C3 outlier',
    title: '',
    transform: value => value/100,
    transformIn: value => value*100,
    transformOut: value => value/100
}

class LayerGroupControl extends PureComponent {
  state = {
    WellsiteNdviLease: true,
    WellsiteNdviControl: false,
    WellsiteEviLease: false,
    WellsiteEviControl: false,
    lease: true,
    control: false,
    vegetation: 'ndvi'
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
    this.handleLayerToggled(name)
  }

  handleRadioChange = name => event => {
    this.setState({ vegetation: event.target.value });
  }

  handleLayerToggled = name => {
    const { handleLayerToggled } = this.props

    handleLayerToggled(name)
  }

  renderCheckbox = layer => {
    const { name, label, layersRendered } = layer
    return (
      <FormControlLabel key={name+'Label'}
        control={
            <Checkbox
                key={name}
                checked={this.state[name]}
                onChange={this.handleChange(name)}
                value={name}
                color='primary'
                />
            }
            label={label}
            />
    )
  }

  render () {
    const {
      classes,
      layer,
      handleLayerToggled,
      layersRendered,
      datetime,
      layerGroup
    } = this.props

    return (
      <Fragment>
        <Legend layer={layerGroup} layer={layer} />
      <FormControl component="fieldset">        
        <FormLabel component="legend">Vegetation index</FormLabel>        
        <FormGroup>
          {layerGroup.map(layer => this.renderCheckbox(layer))}
        </FormGroup>
      </FormControl>
      <ListItem>
        <SliderFilter
          {...filterProps}
          layerName={'WellsiteRank'}
          />
      </ListItem>
      <ListItem>
      <SliderTransparency
        layerName={'WellsiteEviControl'}
        layerOpacity={'raster-opacity'}
        />
      </ListItem>
      <ListItem>
        <SliderDatetimeContainer
          layerName={'WellsiteEviControl'}
          datetimeId={'WellsiteEviControl'}
          datetimeValue={transform(datetime, layer.datetimeTransform) || null}
          />
      </ListItem>
      </Fragment>
    )
  }
}

LayerGroupControl.defaultProps = {
  handleLayerToggled: name => console.log(`Toggled ${name}`)
}

const makeMapStateToProps = () => {
  const getDatetime = makeGetDatetime()

  const mapStateToProps = (state, ownProps) => {
    const { layer } = ownProps
    return {
      datetime: getDatetime(state, layer.datetimeId, getDateFromTimeIso)
    }
  }

  return mapStateToProps
}

export default connect(makeMapStateToProps, null)(withStyles(styles)(LayerGroupControl))



// WEBPACK FOOTER //
// ./src/components/LayerGroupControl.js